import { ReplaySubject } from "rxjs";
import { take } from "rxjs/operators";
var getWebPSupportSubject = function () {
    var subject = new ReplaySubject();
    var img = new Image();
    img.onload = function () { return subject.next(!!(img.height > 0 && img.width > 0)); };
    img.onerror = function () { return subject.next(false); };
    img.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=";
    return subject;
};
var webPSupportSubject$ = getWebPSupportSubject();
export var supportedImageTypeMiddlewareFactory = function () { return function (resource, next) {
    webPSupportSubject$.pipe(take(1)).subscribe(function (supportsWebP) {
        if (resource.data && resource.data.meta) {
            var from = supportsWebP ? ".png" : ".webp";
            var to = supportsWebP ? ".webp" : ".png";
            resource.data.meta.image = resource.data.meta.image.replace(from, to);
        }
        next();
    });
}; };



//////////////////
// WEBPACK FOOTER
// ./src/utils/loader/supportedImageTypeMiddlewareFactory.ts
// module id = 1916
// module chunks = 3